<template>
  <div class="package-name-background p-2"><p>{{ item.label }} </p></div>
</template>

<script>
export default {
  name: 'PackageItemInfo',
  props: ['item']
}
</script>
